import { useAgencyInfo } from "context/agency";
import { useAppServices } from "hook/services"
import React from "react"
import { useState } from "react"
import toast from "react-hot-toast";

const index = () => {
  const [agency, Update] = useAgencyInfo();
  const [googleProcessing, setGoogleProcessing] = useState(false)
  const [headerCode, setHeaderCode] = useState(agency?.customCode?.headerCode || "")
  const [bodyCode, setBodyCode] = useState(agency?.customCode?.bodyCode || "")
  const AppService = useAppServices();

  const handleSaveCode = async (e) => {
    e.preventDefault()
    setGoogleProcessing(true)
    const payload = {
      _id: agency._id,
      customCode: {
          headerCode:headerCode,
          bodyCode:bodyCode
      },
    };
    const { response } = await AppService.agency.update({
      payload,
    });
    if (response?.success) {
          Update(response?.data);
          toast.success("Your Code is saved!");
        } else {
          toast.error("Error Code not saved!")
        }
        setGoogleProcessing(false)
  };

  return (
    <div className="code-editor-container">
      {/* <div className="editor-header">
        <h2>Code Editor</h2>
        <p>Manage your header and body code snippets</p>
      </div> */}

      <form onSubmit={handleSaveCode} className="editor-form">
        <div className="form-content">
          <div className="code-section">
            <div className="input-group">
              <label htmlFor="header-code" className="input-label">
                Header Code
                <span className="label-description">Add your HTML head section code</span>
              </label>
              <div className="textarea-wrapper">
                <textarea
                  id="header-code"
                  value={headerCode}
                  onChange={(e) => setHeaderCode(e.target.value)}
                  placeholder="<!-- Enter your header code here -->"
                  className="code-textarea"
                  rows={8}
                />
                <div className="textarea-footer">
                  <span className="char-count">{headerCode.length} characters</span>
                </div>
              </div>
            </div>

            <div className="input-group">
              <label htmlFor="body-code" className="input-label">
                Body Code
                <span className="label-description">Add your HTML body section code</span>
              </label>
              <div className="textarea-wrapper">
                <textarea
                  id="body-code"
                  value={bodyCode}
                  onChange={(e) => setBodyCode(e.target.value)}
                  placeholder="<!-- Enter your body code here -->"
                  className="code-textarea"
                  rows={8}
                />
                <div className="textarea-footer">
                  <span className="char-count">{bodyCode.length} characters</span>
                </div>
              </div>
            </div>
          </div>

          <div className="action-section">
            <div className="save-panel">
              <div className="save-info">
                <h3>Ready to Save?</h3>
                <p>Your code changes will be applied immediately after saving.</p>
              </div>

              <button
                type="submit"
                disabled={googleProcessing}
                className={`save-button ${googleProcessing ? "loading" : ""}`}
              >
                {googleProcessing ? (
                  <>
                    <div className="spinner"></div>
                    Saving...
                  </>
                ) : (
                  <>
                    <svg className="save-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
                      <polyline points="17,21 17,13 7,13 7,21" />
                      <polyline points="7,3 7,8 15,8" />
                    </svg>
                    Save Code
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </form>

      <style jsx>{`
        .code-editor-container {
          padding: 24px;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        }

        .editor-header h2 {
          font-size: 28px;
          font-weight: 700;
          color: #111827;
          margin: 0 0 8px 0;
        }

        .editor-header p {
          font-size: 16px;
          color: #6b7280;
          margin: 0;
        }

        .editor-form {
          background: white;
          border-radius: 12px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
          overflow: hidden;
        }

        .form-content {
          display: grid;
          grid-template-columns: 1fr 300px;
          min-height: 600px;
        }

        .code-section {
          padding: 32px;
          display: flex;
          flex-direction: column;
          gap: 24px;
        }

        .input-group {
          display: flex;
          flex-direction: column;
        }

        .input-label {
          font-size: 14px;
          font-weight: 600;
          color: #374151;
          margin-bottom: 8px;
          display: flex;
          flex-direction: column;
          gap: 4px;
        }

        .label-description {
          font-size: 12px;
          font-weight: 400;
          color: #6b7280;
        }

        .textarea-wrapper {
          position: relative;
          border: 1px solid #d1d5db;
          border-radius: 8px;
          overflow: hidden;
          transition: border-color 0.2s ease;
        }

        .textarea-wrapper:focus-within {
          border-color: #3b82f6;
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
        }

        .code-textarea {
          width: 100%;
          border: none;
          outline: none;
          padding: 16px;
          font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
          font-size: 14px;
          line-height: 1.5;
          background: #f9fafb;
          color: #374151;
          resize: vertical;
          min-height: 120px;
        }

        .code-textarea::placeholder {
          color: #9ca3af;
        }

        .textarea-footer {
          padding: 8px 16px;
          background: #f3f4f6;
          border-top: 1px solid #e5e7eb;
          display: flex;
          justify-content: flex-end;
        }

        .char-count {
          font-size: 12px;
          color: #6b7280;
        }

        .action-section {
          background: #f8fafc;
          border-left: 1px solid #e5e7eb;
          padding: 32px 24px;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        .save-panel {
          text-align: center;
        }

        .save-info {
          margin-bottom: 24px;
        }

        .save-info h3 {
          font-size: 18px;
          font-weight: 600;
          color: #111827;
          margin: 0 0 8px 0;
        }

        .save-info p {
          font-size: 14px;
          color: #6b7280;
          margin: 0;
          line-height: 1.5;
        }

        .save-button {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          width: 100%;
          padding: 12px 24px;
          background: #111827;
          color: white;
          border: none;
          border-radius: 8px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
          min-height: 48px;
        }

        .save-button:hover:not(:disabled) {
          background: #1f2937;
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }

        .save-button:disabled {
          background: #9ca3af;
          cursor: not-allowed;
          transform: none;
          box-shadow: none;
        }

        .save-button.loading {
          background: #3b82f6;
        }

        .save-icon {
          width: 16px;
          height: 16px;
        }

        .spinner {
          width: 16px;
          height: 16px;
          border: 2px solid rgba(255, 255, 255, 0.3);
          border-top: 2px solid white;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        @media (max-width: 768px) {
          .code-editor-container {
            padding: 16px;
          }

          .form-content {
            grid-template-columns: 1fr;
          }

          .action-section {
            border-left: none;
            border-top: 1px solid #e5e7eb;
            padding: 24px;
          }

          .code-section {
            padding: 24px;
          }

          .editor-header h2 {
            font-size: 24px;
          }
        }
      `}</style>
    </div>
  )
}

export default index